import {
  ApplicantForChecklist,
  ApplicationForChecklist,
  Boat,
  Checklist,
  ChecklistItem,
  ChecklistStatus,
} from "./types";
import { DocumentData } from "firebase/firestore";
import { getDate } from "@poseidon/firebase/timestamp";

export const boatDetailsValid = (boat: Boat | undefined) => {
  return (
    !!(
      boat &&
      boat.hin &&
      boat.make &&
      boat.model &&
      boat.type &&
      boat.yearBuilt &&
      boat.engineType &&
      boat.engineNumber
    ) || null
  );
};
export const checkApplicants = (
  application: ApplicationForChecklist,
  check: (applicant: ApplicantForChecklist | undefined) => ChecklistStatus
): ChecklistStatus => {
  const mainApplicantStatus: ChecklistStatus = check(application.applicant);
  const jointApplicantStatus: ChecklistStatus = application.isJoint
    ? check(application.jointApplicant)
    : "not-applicable";
  if (mainApplicantStatus === false || jointApplicantStatus === false) {
    return false;
  }
  if (mainApplicantStatus !== true) {
    return mainApplicantStatus;
  }
  if (
    (application.isJoint ? jointApplicantStatus : mainApplicantStatus) === true
  ) {
    return true;
  }
  return null;
};
export const checkApplicantsProgressTrackers = (
  application: ApplicationForChecklist,
  sailorTracker: Record<string, unknown> | undefined,
  jointTracker: Record<string, unknown> | undefined,
  check: (checklist: Record<string, unknown>) => ChecklistStatus
): ChecklistStatus => {
  const mainApplicantStatus: ChecklistStatus = sailorTracker
    ? check(sailorTracker)
    : null;
  const jointApplicantStatus: ChecklistStatus = application.isJoint
    ? jointTracker
      ? check(jointTracker)
      : null
    : "not-applicable";
  if (mainApplicantStatus === false || jointApplicantStatus === false) {
    return false;
  }
  if (mainApplicantStatus !== true) {
    return mainApplicantStatus;
  }
  if (!application.isJoint || jointApplicantStatus === true) {
    return true;
  }
  return null;
};
export const actionBlocked = (
  checkData: Checklist,
  dependencies: ChecklistItem[]
) => {
  return dependencies.some(
    (d) => checkData[d] !== true && checkData[d] !== "not-applicable"
  );
};
export const affordabilityCheckDone = (
  affordabilityReport: DocumentData | undefined
) => {
  if (!affordabilityReport) {
    return null;
  }
  return affordabilityReport["declared"]?.isAffordable
    ? affordabilityReport["manual"]?.isAffordable !== false
    : !!affordabilityReport["manual"]?.isAffordable;
};
export const progressTrackerCheckIsComplete = (
  tracker: Record<string, unknown> | undefined,
  check: string
) => {
  if (!tracker) {
    return null;
  }
  if (tracker[`check_${check}_state`] === "complete") {
    return true;
  }
  if (
    tracker[`check_${check}_state`] === "actionRequired" &&
    tracker[`check_${check}_note`]
  ) {
    return false;
  }
  return null;
};
export const progressTrackerActionIsComplete = (
  tracker: Record<string, unknown> | undefined,
  action: string
) => {
  if (!tracker) {
    return null;
  }
  if (tracker[`action_${action}_state`] === "complete") {
    return true;
  }
  if (tracker[`action_${action}_state`] === "pendingApproval") {
    return "pendingApproval";
  }
  if (
    tracker[`action_${action}_state`] === "actionRequired" &&
    tracker[`action_${action}_note`]
  ) {
    return false;
  }
  return null;
};

export function calculateCreditApproved(
  applicationProgressTracker: Record<string, unknown> | undefined
): ChecklistStatus {
  if (!applicationProgressTracker) {
    return null;
  }
  if (applicationProgressTracker["check_creditDecision_state"] === "pass") {
    const expiry = getDate(applicationProgressTracker["creditDecisionExpiry"]);
    const now = new Date();
    return !!expiry && expiry > now;
  }
  if (applicationProgressTracker["check_creditDecision_state"] === "fail") {
    return false;
  }
  return null;
}

export function mcaDetailsValid(application: ApplicationForChecklist) {
  if (!application.mcaRegistrationRequired) {
    return "not-applicable";
  }
  return !!(
    application.portOfRegistration && application.portPreferredVesselNameOne
  );
}

export function getSailorLink(
  sailorId: string | undefined,
  applicationId?: string | undefined,
  subPath?: string | undefined
) {
  if (!sailorId) {
    return undefined;
  }
  if (applicationId) {
    return `/applications/${applicationId}/sailors/${sailorId}${subPath ?? ""}`;
  }
  return `/sailors/${sailorId}${subPath ?? ""}`;
}
